// Generated types for MaterialExtractionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EntityExtractionTaskReadAPI, EntityExtractionTaskWriteAPI } from './entityextractiontask';
import { EntityExtractionTaskReadAPISchemaObject, EntityExtractionTaskWriteAPISchemaObject } from './entityextractiontask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface MaterialExtractionTaskReadAPI extends EntityExtractionTaskReadAPI {
}

export interface MaterialExtractionTaskWriteAPI extends EntityExtractionTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const MaterialExtractionTaskReadAPISchema: z.ZodType<MaterialExtractionTaskReadAPI> = EntityExtractionTaskReadAPISchemaObject.extend({}).passthrough();

export const MaterialExtractionTaskWriteAPISchema: z.ZodType<MaterialExtractionTaskWriteAPI> = EntityExtractionTaskWriteAPISchemaObject.extend({}).passthrough();
